import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceAbTestingSettings } from './settings/slice-ab-testing-settings.model';


export const SliceAbTestingDefinition: IdtComponentDefinition = {
  id: 'slice-ab-testing',
  role: IdtComponentRole.Slice,
  numSlots: 2,
  defaultSlot: 1
};

export const SliceAbTestingCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Test A/B',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web'],
  initialSettings: (): SliceAbTestingSettings => ({
    general: {
      numSlots: 2,
      percentageA: 50,
      percentageB: 50
    },
    slots: [
      { ...initialSliceSlotState },
      { ...initialSliceSlotState }
    ],
    styles: {
      ...SliceStylesDefaultValues
    }
  })
};
